export const MAX_CHILDREN_PER_PARENT = 9

export function stageDisplayNumber(
  parentIndex: number,
  childIndex?: number,
): string {
  const base = (parentIndex + 1) * 10
  const n = childIndex === undefined ? base : base + childIndex + 1
  return `#${n}`
}

export function stageLabel(parentIndex: number, childIndex?: number): string {
  return `ETAPA ${stageDisplayNumber(parentIndex, childIndex)}`
}
